import { Card, Group, Stack, Text } from '@mantine/core';
import { Sparkline } from '@mantine/charts';

// Single metric tile: top-aligned label, big primary number, then a 3-row
// today/yesterday/last-7d table on the left and a sparkline on the right.
// Mirrors adset.pro's Tracker → Dashboard tiles.
export function MetricTile({
  label,
  total,
  today,
  yesterday,
  last7,
  series,
  color = 'brand.6',
  formatter = (n: number) => n.toLocaleString(),
}: {
  label: string;
  total: number;
  today: number;
  yesterday: number;
  last7: number;
  series: number[];
  color?: string;
  formatter?: (n: number) => string;
}) {
  // Show a flat baseline when there's no data so the tile doesn't look broken.
  const data = series.length > 0 ? series : [0, 0, 0];
  return (
    <Card>
      <Stack gap="xs">
        <Text fz="sm" fw={600} c="dimmed" tt="uppercase" lts={0.4}>{label}</Text>
        <Text fz={28} fw={800} lh={1}>{formatter(total)}</Text>
        <Group justify="space-between" align="center" wrap="nowrap" mt={4}>
          <Stack gap={1} miw={92}>
            <Group justify="space-between" gap="xs"><Text fz="xs" c="dimmed">Today</Text><Text fz="xs" fw={600}>{formatter(today)}</Text></Group>
            <Group justify="space-between" gap="xs"><Text fz="xs" c="dimmed">Yesterday</Text><Text fz="xs" fw={600}>{formatter(yesterday)}</Text></Group>
            <Group justify="space-between" gap="xs"><Text fz="xs" c="dimmed">Last 7 days</Text><Text fz="xs" fw={600}>{formatter(last7)}</Text></Group>
          </Stack>
          <Sparkline
            data={data}
            color={color}
            fillOpacity={0.18}
            strokeWidth={2}
            curveType="natural"
            w={120}
            h={48}
          />
        </Group>
      </Stack>
    </Card>
  );
}
